import React from 'react';
import { FillContainer } from '@layout';
import styles from './FiftyFifty.module.scss';
import classNames from 'classnames';

export default function FiftyFifty({
  className,
  textClassName,
  photoClassName,
  rightAlignDots = false,
  clipImage = true,
  image,
  children
}) {
  const imageComponent = !image ? null : (
    <div className={styles.imageWrapper}>
      <div
        className={classNames(styles.image, photoClassName, {
          [styles.noClip]: !clipImage
        })}
        style={{
          backgroundImage: !image ? null : `url('${image}')`
        }}
      />
    </div>
  );

  return (
    <FillContainer
      className={classNames(styles.wrapper, className)}
      tag="section"
      showDots
      rightAlignDots={rightAlignDots}
      contentAfter={imageComponent}
      wrapContent={false}
    >
      <div className={classNames(styles.text, textClassName)}>
        {children}
      </div>
    </FillContainer>
  );
}
